import { useSnapshot } from "valtio";
import { contentCatalogStore } from "../contentCatalogStore";
import { ContentCatalogFolder } from "@models/contentCatalogFolder.model";
import CollectionAccordion from "./CollectionAccordion";
import type { Ad } from "@models/Ad.model";
import type { AdMenuItemsFn, FolderMenuItemsFn } from "../contentCatalog";

export default function CollectionView({
    node,
    onAdClick,
    adMenuItems,
    folderMenuItems,
    enableDnd,
}: {
    node: ContentCatalogFolder | null;
    onAdClick?: (ad: Ad) => void;
    adMenuItems?: AdMenuItemsFn;
    folderMenuItems?: FolderMenuItemsFn;
    enableDnd?: boolean;
}) {
    const { collections } = useSnapshot(contentCatalogStore);
    const items = node ? [node] : (collections as ContentCatalogFolder[]);

    return (
        <div className="content-area">
            <div className="col-accordion-list">
                {items.map((item) => (
                    <CollectionAccordion
                        key={item.id}
                        node={item}
                        section="collection"
                        depth={0}
                        parentFolderId={null}
                        onAdClick={onAdClick}
                        adMenuItems={adMenuItems}
                        folderMenuItems={folderMenuItems}
                        enableDnd={enableDnd}
                    />
                ))}
            </div>
        </div>
    );
}
